import { useParams } from 'react-router-dom';
import {
  ISigningAppointmentResponse,
  sortSigningAppointments,
} from '../../../types/signingAppointment/ISigningAppointmentResponse';
import { useListSigningAppointmentsQuery } from '../../../API/order/signingAppointment/SigningAppointmentAPI';
import { useMemo } from 'react';
import { eConsumerTypes } from '../../../types/order/consumer/eConsumerTypes';

interface SortedBorrowerAndSellerSigningAppointments {
  borrowerAppointments: ISigningAppointmentResponse[];
  sellerAppointments: ISigningAppointmentResponse[];
  isSigningAppointmentsLoading: boolean;
}

export const useListSortedSigningAppointments = (): SortedBorrowerAndSellerSigningAppointments => {
  const { orderId } = useParams<{ orderId: string }>();
  const { data: signingAppointments = [], isLoading: isSigningAppointmentsLoading } = useListSigningAppointmentsQuery({
    orderId,
  });

  const { borrowerAppointments, sellerAppointments } = useMemo(() => {
    const sortedSigningAppointments = sortSigningAppointments(signingAppointments);
    return {
      borrowerAppointments: sortedSigningAppointments.filter((apt) => apt.ownerType === eConsumerTypes.borrower),
      sellerAppointments: sortedSigningAppointments.filter((apt) => apt.ownerType === eConsumerTypes.seller),
    };
  }, [signingAppointments]);
  return { borrowerAppointments, sellerAppointments, isSigningAppointmentsLoading };
};
